import { invoiceInfoCreateValidationSchema } from '../InvoiceInfoCreate/InvoiceInfoCreate.validations'

export const invoiceInfoUpdateValidationSchema =
    invoiceInfoCreateValidationSchema.shape({})
